import Vue from 'vue';
import { ValidationProvider, localize, extend, ValidationObserver } from "vee-validate";
import { get as _get } from "lodash";
Vue.prototype.$setErrorsFromResponse = function (errorResponse) {
    // Only allow this function to be run if the validator exists
    // and an error response was given.
    if (!Object.prototype.hasOwnProperty.call(this, '$validator') || !errorResponse) {
        console.log("nothing");
        return;
    }
    console.log(Object.prototype.hasOwnProperty.call(this, '$validator'), "here");
    // Check for error fields.
    const keys = Object.keys(errorResponse);
    if (keys.length === 0) {
        return;
    }
    // Clear errors in the Vue object.
    this.$ref.form.reset();
    const errorFields = [];
    keys.forEach(field => {
        // If the field has a dot, it means it's part of an array input
        if (field.indexOf(".") > -1) {
            // Reconstruct the original field name. ex. 'urls[]'
            const fieldOriginalName = `${field.split(".")[0]}[]`;
            // If we don't have it in the resultant error fields, add it, otherwise
            // only push the error as an array to the original response object.
            if (!errorFields[fieldOriginalName]) {
                errorFields.push(fieldOriginalName);
                errorResponse[fieldOriginalName] = [errorResponse[field]];
            }
            else {
                errorResponse[fieldOriginalName].push(errorResponse[field]);
            }
        }
        else {
            // Otherwise just add it to the list.
            errorFields.push(field);
        }
    });
    errorFields.forEach(field => {
        const errorValue = errorResponse[field];
        const errorString = errorValue instanceof Array ? errorValue.join(', ') : errorValue;
        //this.$validator.errors.add({field: field, msg: errorString});
    });
};
Vue.prototype.__ = (key, bindings) => {
    if (!window.l) {
        throw "No localization in window variable.";
    }
    let translation = _get(window.l, key);
    if (translation && bindings) {
        for (const key in bindings) {
            const value = bindings[key];
            translation = translation.replace(`:${key}`, value);
        }
    }
    return translation;
};
Vue.prototype.assignJSONObject = (from, to) => {
    for (const key in from) {
        if (Object.prototype.hasOwnProperty.call(from, key)) {
            to[key] = from[key];
        }
    }
    return to;
};
Vue.prototype.asset = (path) => {
    if (!window.v.cdn) {
        return `//www.venngo.com/${path}`;
    }
    if (window.v.cdn[window.v.cdn.length - 1] === "/") {
        window.v.cdn = window.v.cdn.slice(0, -1);
    }
    return window.v.cdn + path;
};
const defaultDict = {
    en: {
        messages: {
            required() {
                return 'Required';
            },
            length(fieldName, params) {
                return `${fieldName} must be between ${params[0]} and ${params[1]} characters.`;
            },
        },
    },
    fr: {
        messages: {
            required() {
                return `Requis`;
            },
            length(fieldName, params) {
                return `${fieldName} doit être entre ${params[0]} et ${params[1]} caractères.`;
            },
            email(field) {
                return `Le champ ${field} doit être une adresse courriel valide.`;
            }
        },
    }
};
// if(window.l.locale === 'fr') {
//     localize('fr', fr);
// }
// Use VeeValidate add rules
extend('required', {
    validate(value) {
        return {
            required: true,
            valid: ['', null, undefined].indexOf(value) === -1
        };
    },
    computesRequired: true
});
Vue.mixin({
    data() {
        return {
            hasError(name) {
                if (this["errors"]) {
                    return this["errors"].first(name) || false;
                }
                return false;
            },
        };
    },
    created() {
        localize(defaultDict);
        localize(window.l.locale);
    },
    components: {
        ValidationProvider,
        ValidationObserver
    }
});
